module.exports = __webpack_public_path__ + "static/media/C2.bdd3133c.jpg";